import { ASSISTANTS  } from "../config/assistants"; 
import { currentAssistant } from '../components/AssistantSelector';
import { MODELS } from "../config/models";

export const getCurrentUser = () => {
    try {
      console.log("Local Storage : ", localStorage);
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      console.log("apiClient.js : UserInfo : ", userInfo);
      return userInfo?.email || "Anonymous";
    } catch (err) {
      console.warn("Failed to get user info from localStorage:", err);
      return "Anonymous";
    }
};


export const sendMessage = async (assistant, messages, sessionId, createSession, selectedModel) => {

    const userId = getCurrentUser();
    console.log("Current User : ", userId);

    console.log("Messages Start")
    console.log(messages)
    console.log(messages[messages.length - 1].content)
    console.log("Messages End")

    const url = ASSISTANTS[assistant].apiUrl;
    const modelId = MODELS[selectedModel].modelId;
    const params = {
        "action": "send_message",
        "user_id": userId, //"Employee",
        "session_id": sessionId,
        "query": messages[messages.length - 1].content,
        "history": JSON.stringify(messages),
        "createSession": createSession ? "true" : "false",
        "model_id": modelId, 
    }

    // Convert params to a URL query string
    const queryString = new URLSearchParams(params).toString();
    console.log("Query String : ",  queryString);
    // Append query string to your base URL
    const fullUrl = `${url}?${queryString}`;
    console.log("Full URL : ", fullUrl)

    const response = await fetch(fullUrl, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        //mode : 'no-cors'
        //body: JSON.stringify( { messages } ),
    });

    //console.log(response)
    if( !response.ok ) {
        console.log("Error")
        throw new Error("API Error");
    }

    const data = await response.json();
    console.log(data)
    const source  = data.source.replace(/[\r\n]/g,"");
    const botReply = data.answer + "\n\nSource : " + source || "No response from assistant.";
    const botSource = data.source || "None";
    return { answer: botReply, source: botSource };
};


export const getUserSessions = async (userId, assistantKey, selectedModel) => {
    const modelId = MODELS[selectedModel].modelId;

    const params = new URLSearchParams({
      action: "get_history",
      user_id: userId,
      session_id: "",
      model_id: modelId, 
    });
  
    console.log("apiClient.js : ASSISTANTS = ", ASSISTANTS);
    console.log("apiClient.js : assistantKey = ", assistantKey);
    console.log("apiClient.js : selectedModel = ", selectedModel);
    const url = ASSISTANTS[assistantKey].apiUrl;

    const fullUrl = `${url}?${params.toString()}`;
    console.log("Full URL : ", fullUrl)

    const response = await fetch(fullUrl, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        //mode : 'no-cors'
        //body: JSON.stringify( { messages } ),
    });


    if (!response.ok) throw new Error("Failed to load history");
  
    const data = await response.json();
  
    // Filter session headers
    const sessions = data.history.filter(item => item.type === "session");
  
    return sessions.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
};


export const getFullHistory = async (userId, assistantKey, selectedModel) => {
    const modelId = MODELS[selectedModel].modelId;

    const params = new URLSearchParams({
      action: "get_history",
      user_id: userId,
      model_id: modelId,
    });
  
    const url = ASSISTANTS[assistantKey].apiUrl;
    const fullUrl = `${url}?${params.toString()}`;
  
    const response = await fetch(fullUrl, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  
    if (!response.ok) throw new Error("Failed to load full history");
  
    const data = await response.json();
    return data.history || [];
};

  
export const getSessionMessages = (history, sessionId) => {
    console.log("apiclient.js : getSessionMessages = Loading");
    console.log("apiclient.js : History : ", history);
    console.log("apiclient.js : SessionId : ", sessionId);
    return history
      .filter(item => item.session_id?.startsWith(sessionId)  && item.type !== "session")
      .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))
      .map(item => [
        {
          role: "user",
          content: item.query,
          timestamp: item.timestamp
        },
        {
          role: "assistant",
          content: item.answer,
          timestamp: item.bot_timestamp,
          source: item.source
        }
      ])
      .flat();
};




